import React from "react";

const isDev = process.env.REACT_APP_DEVELOPMENT_MODE === "development";
const logoSrc = isDev ? "./dashboard/images/meetuslogosvg.svg" : "./images/meetuslogosvg.svg";

const MeetUsLogo = ({ className }) => (
  <img
    src={logoSrc}
    alt="MeetusVR"
    className={className}
    style={{ width: 120, height: "auto" }}
  />
);

export default MeetUsLogo;
